<template>
    <div>
        <config-main-title>
            NPS: Comunicação de Detratores
        </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-3 offset-md-9 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir_destino()">
                    Incluir
                </button>
            </div>
        </div>

        <az-empty-state v-if="!dados || !dados.length" />

        <div v-else>
            <div class="card dashcard">
                <div class="card-body">
                    <div class="form-row" v-for="(destino, idx) in dados" :key="idx">
                        <div class="col col-12 col-md-3">
                            <az-input
                                sizing="sm"
                                type="select"
                                optionsMode="json"
                                :optionsList="[
                                    { id: 'E', search: 'e-mail' },
                                    { id: 'T', search: 'Telegram' },
                                ]"
                                optionsData="id"
                                :validate="validate"
                                required
                                v-model="destino.tipo" />
                        </div>
                        <div class="col col-12 col-md-5">
                            <az-input
                                sizing="sm"
                                :type="destino.tipo == 'E' ? 'email' : 'number'"
                                v-if="destino.tipo"
                                :placeholder="destino.tipo == 'E' ? 'e-mail' : 'Id do Telegram'"
                                :validate="validate"
                                required
                                v-model="destino.conta">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend input-group-sm">
                                        <button class="btn btn-outline-danger btn-sm" type="button" id="button-addon1" @click="remove_destino(idx)">
                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input
                                sizing="sm"
                                placeholder="Nome..."
                                :validate="validate"
                                v-model="destino.nome" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false">{{ dados }}</pre>

        <br><br><br>

        <nav class="navbar fixed-bottom navbar-light bg-light" v-if="dados">
            <div>
                <az-submit @click="atualizar ()" class="mr-2">Atualizar</az-submit>
                <!-- 
                    <az-audit-log-button model="parametroUnidade" :id="lista.id_parametro_unidade"/>
                -->
            </div>
        </nav>
           
    </div>
</template>

<script>
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            dados: [],
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzEmptyState, 
        ConfigMainTitle,
        AzSubmit, 
    },

    methods: { 
        incluir_destino() { 
            this.dados.push({
                tipo: 'E',
                conta: "", 
            });
        },

        remove_destino(idx) { 
            this.dados.splice(idx,1);
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'nps',
                func: 'nps_comunic_salvar',
                dados: this.dados,
                toast: true, 
            });
        },
    },

    mounted() { 
        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "NPS: Comunicação de Detratores" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.load(this, { 
            service: 'nps',
            func: 'nps_comunic', 
            parms: { 
                cadastro: true,
            },
            callback: res => { 
                this.dados = res;
            }
        });
    }
}
</script>